import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_PORT'),
  ...asyncTypes('CREATE_PORT'),
  ...asyncTypes('ARCHIVE_PORT'),
  ...asyncTypes('UNARCHIVE_PORT')
};

export default TYPES;
